import { NOTIFICATION_SEVERITY, NOTIFICATION_TYPE } from './notification-drawer.const'
import type { Notification } from './notification-drawer.type'

export const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: 'notif-1',
    type: NOTIFICATION_TYPE.NEW_PACKAGE_VERSION,
    severity: NOTIFICATION_SEVERITY.INFO,
    titleKey: 'types.newPackageVersion',
    description: [
      { text: 'query-inspector-python v4.3.0 → v4.3.1', emphasis: true },
      { text: ' is now available. Includes bug fixes and minor performance improvements.' },
    ],
    timestamp: '3:40 AM',
    isRead: false,
  },
  {
    id: 'notif-2',
    type: NOTIFICATION_TYPE.SCHEDULED_MAINTENANCE,
    severity: NOTIFICATION_SEVERITY.INFO,
    titleKey: 'types.scheduledMaintenance',
    description: [
      { text: 'Planned maintenance on ' },
      { text: 'Aug 30, 01:00–03:00 UTC.', emphasis: true },
      { text: ' Minor downtime may occur.' },
    ],
    timestamp: '3:40 AM',
    isRead: false,
  },
  {
    id: 'notif-3',
    type: NOTIFICATION_TYPE.INVITED_TO_ORGANIZATION,
    severity: NOTIFICATION_SEVERITY.INFO,
    titleKey: 'types.invitedToOrganization',
    description: [
      { text: 'You’ve been invited to join ' },
      { text: 'Acme Corp Workspace', emphasis: true },
      { text: ' by ' },
      { text: 'Alex Johnson', emphasis: true },
      { text: '.' },
    ],
    timestamp: '3:40 AM',
    isRead: false,
    actions: [
      { id: 'join', labelKey: 'actions.join', variant: 'primary' },
      { id: 'decline', labelKey: 'actions.decline', variant: 'outlined' },
    ],
  },
  {
    id: 'notif-4',
    type: NOTIFICATION_TYPE.HIGH_LATENCY_ALERT,
    severity: NOTIFICATION_SEVERITY.WARNING,
    titleKey: 'types.highLatencyAlert',
    description: [
      { text: 'API Gateway latency (p95)', emphasis: true },
      { text: ' exceeded ' },
      { text: '500ms', emphasis: true },
      { text: ' in the last 5 minutes.' },
    ],
    timestamp: '3:40 AM',
    isRead: false,
  },
  {
    id: 'notif-5',
    type: NOTIFICATION_TYPE.ROLE_PERMISSION_CHANGE,
    severity: NOTIFICATION_SEVERITY.INFO,
    titleKey: 'types.rolePermissionChange',
    description: [
      { text: 'Your role has been updated to ' },
      { text: 'Admin', emphasis: true },
      { text: ' in ' },
      { text: 'Sample Project Name', emphasis: true },
      { text: ' project.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-6',
    type: NOTIFICATION_TYPE.CRITICAL_VULNERABILITY,
    severity: NOTIFICATION_SEVERITY.CRITICAL,
    titleKey: 'types.criticalVulnerability',
    description: [
      { text: 'Critical RCE vulnerability found in ' },
      { text: 'express-auth-middleware', emphasis: true },
      { text: ' (CVE-2025-4421). Immediate patch required.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-7',
    type: NOTIFICATION_TYPE.DAILY_DIGEST,
    severity: NOTIFICATION_SEVERITY.INFO,
    titleKey: 'types.dailyDigest',
    description: [
      { text: 'Summary (Aug 27):', emphasis: true, breakAfter: true },
      { text: '3 services active, 1 degraded, 2 vulnerabilities flagged.', medium: true },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-8',
    type: NOTIFICATION_TYPE.DEPRECATED_PACKAGE,
    severity: NOTIFICATION_SEVERITY.WARNING,
    titleKey: 'types.deprecatedPackage',
    description: [
      { text: 'The package ' },
      { text: 'vue-draggable', emphasis: true },
      { text: ' has been marked as deprecated. Consider migrating to the recommended replacement.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-9',
    type: NOTIFICATION_TYPE.CONNECTION_ERROR,
    severity: NOTIFICATION_SEVERITY.CRITICAL,
    titleKey: 'types.connectionError',
    description: [
      { text: 'Connection between ' },
      { text: 'User service → Payments DB', emphasis: true },
      { text: ' failed. Retrying requests.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-10',
    type: NOTIFICATION_TYPE.SERVICE_DEGRADED,
    severity: NOTIFICATION_SEVERITY.WARNING,
    titleKey: 'types.serviceDegraded',
    description: [
      { text: 'Payments Service', emphasis: true },
      { text: ' error rate reached ' },
      { text: '3.2%', emphasis: true },
      { text: ' (threshold: 1%). Some requests are failing.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-11',
    type: NOTIFICATION_TYPE.UNAUTHORIZED_LOGIN,
    severity: NOTIFICATION_SEVERITY.WARNING,
    titleKey: 'types.unauthorizedLogin',
    description: [
      { text: 'Suspicious login attempt blocked from ' },
      { text: 'IP 185.33.12.77', emphasis: true },
      { text: '. MFA recommended.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-12',
    type: NOTIFICATION_TYPE.WEEKLY_REPORT,
    severity: NOTIFICATION_SEVERITY.INFO,
    titleKey: 'types.weeklyReport',
    description: [
      { text: 'Summary (Aug 19–25):', emphasis: true, breakAfter: true },
      { text: 'Uptime 99.62%, 2 incidents resolved, 5 modules updated.', medium: true },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-13',
    type: NOTIFICATION_TYPE.NEW_FEATURE,
    severity: NOTIFICATION_SEVERITY.INFO,
    titleKey: 'types.newFeature',
    description: [
      { text: 'Service map animations', emphasis: true },
      { text: ' are now live. Explore real-time connection flows.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-14',
    type: NOTIFICATION_TYPE.VULNERABILITY_DETECTED,
    severity: NOTIFICATION_SEVERITY.WARNING,
    titleKey: 'types.vulnerabilityDetected',
    description: [
      { text: 'Moderate vulnerability found in ' },
      { text: 'lodash', emphasis: true },
      { text: ' (CVE-2025-3310). Update recommended.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-15',
    type: NOTIFICATION_TYPE.CERTIFICATE_UPDATE,
    severity: NOTIFICATION_SEVERITY.WARNING,
    titleKey: 'types.certificateUpdate',
    description: [
      { text: 'TLS certificate for ' },
      { text: 'api-gateway.prod', emphasis: true },
      { text: ' expires in 14 days. Renewal required.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
  {
    id: 'notif-16',
    type: NOTIFICATION_TYPE.SYSTEM_ANNOUNCEMENT,
    severity: NOTIFICATION_SEVERITY.INFO,
    titleKey: 'types.systemAnnouncement',
    description: [
      { text: 'Workspace backup policy', emphasis: true },
      { text: ' has been updated. Review your retention settings.' },
    ],
    timestamp: '3:40 AM',
    isRead: true,
  },
]
